import http from "../http-common";

const getDevicesOnFloor = (floorId) => {
  return http.get(`/v1/device-floors/floor/${floorId}`);
};

const getFloorsForDevice = (deviceId) => {
  return http.get(`/v1/device-floors/device/${deviceId}`);
};

const bulkAssign = (data) => {
  return http.post("/v1/device-floors/bulk-assign", data);
};

const bulkRemove = (floorId, deviceIds) => {
  return http.delete(`/v1/device-floors/bulk-remove/${floorId}`, {
    data: { deviceIds },
  });
};

const getUnassignedDevices = (loc) => {
  return http.get(`/v1/device-floors/unassigned/loc/${loc}`);
};

export default {
  getDevicesOnFloor,
  getFloorsForDevice,
  bulkAssign,
  bulkRemove,
  getUnassignedDevices,
};
